import React from "react";
import {observer} from "mobx-react";
import Utility from "../../Utility";
import GeneralDialog from "./GeneralDialog";
import {useStores} from "../../Hooks";

const ProcedureStatsModal = observer(() => {
    const {procedureStore, generalStore} = useStores();
    
    const mostAbandoned = procedureStore.mostAbandoned || '-';
    const mostAbandonedNoHtml = mostAbandoned
        .replace(/<\/?[^>]+(>|$)/g, "");
    const mostAbandonedNoSpecialChars = Utility.removeHtmlSpecialChars(mostAbandonedNoHtml);

    const renderStatsBody = () => {
        return (
            <div className="procedure-analytics">
                <div className="basic-stats-body">
                    <div className="basic-stat-container">
                        <div className="procedure-stat-title">{generalStore.translate('averageDuration')}</div>
                        <div className="procedure-stat">{procedureStore.averageTime}</div>
                    </div>
                    <div className="basic-stat-container">
                        <div className="procedure-stat-title">{generalStore.translate('views')}</div>
                        <div className="procedure-stat">{procedureStore.procedureViews}</div>
                    </div>
                    <div className="basic-stat-container">
                        <div className="procedure-stat-title">{generalStore.translate('completedSessions')}</div>
                        <div className="procedure-stat">{procedureStore.completedSessions}</div>
                    </div>
                </div>
                <div className="most-abandoned-body">
                    <div className="procedure-stat-title">{generalStore.translate('mostAbandonedStep')}</div>
                    <div className="procedure-stat most-abandoned">{mostAbandonedNoSpecialChars}</div>
                </div>
            </div>
        )
    }

    return (
        <GeneralDialog
            openControl='isProcedureStatsModalOpen'
            className='procedure-option-dialog'
            onEnter={null}
            title={generalStore.translate('basicStatistics')}
            body={renderStatsBody()}
            isConfirmDisabled={true}
            onConfirm={null}
        />
    );
})

export default ProcedureStatsModal;
